import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipAdd, tooltipHide, tooltipRemove } from '../../../actions/tooltipActions';

// components
import { TooltipHeader } from '../_tooltip';

class Tooltip extends React.Component {
  static propTypes = {
    add:      PropTypes.func.isRequired,
    header:   PropTypes.string,
    hide:     PropTypes.func.isRequired,
    id:       PropTypes.string.isRequired,
    onClose:  PropTypes.func,
    remove:   PropTypes.func.isRequired,
    tooltip:  PropTypes.instanceOf(Immutable.Map).isRequired
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map({
      insideClick: false
    }) };
  }

  componentWillMount() {
    const { id, add } = this.props;

    add(id);
  }

  componentWillReceiveProps(nextProps) {
    const currentTooltip = (this.props.tooltip.get('data') || Immutable.Map()).get(this.props.id) || Immutable.Map();
    const nextTooltip    = (nextProps.tooltip.get('data') || Immutable.Map()).get(nextProps.id) || Immutable.Map();

    const currentActive = currentTooltip.get('active');
    const nextActive    = nextTooltip.get('active');

    if (nextActive) {
      document.addEventListener('click', this._handleOutsideClick);
    } else if (currentActive && !nextActive) {
      this._removeClickEventListener();
    }
  }

  componentWillUnmount() {
    const { id, remove } = this.props;

    this._removeClickEventListener();

    remove(id);
  }

  render() {
    const { children, className, header, id, tooltip } = this.props;

    const active = ((tooltip.get('data') || Immutable.Map()).get(id) || Immutable.Map()).get('active');

    let element = null;

    if (active) {
      element = (
        <div className={ classNames('tooltip', className) } onMouseDown={ this._handleInsideClick }>
          <TooltipHeader label={ header } onClose={ this._handleClose } />
          { children }
        </div>
      );
    }

    return element;
  }

  // private

  _handleClose        = this._handleClose.bind(this);
  _handleInsideClick  = this._handleInsideClick.bind(this);
  _handleOutsideClick = this._handleOutsideClick.bind(this);

  _handleInsideClick() {
    this.setState({ data: this.state.data.set('insideClick', true) });
  }

  _handleClose() {
    const { hide, id, onClose } = this.props;

    this.setState({ data: this.state.data.set('insideClick', false) });

    hide(id);

    if (onClose) {
      onClose();
    }
  }

  _handleOutsideClick(e) {
    const { id, tooltip } = this.props;

    const active      = ((tooltip.get('data') || Immutable.Map()).get(id) || Immutable.Map()).get('active') || false;
    const insideClick = this.state.data.get('insideClick');
    if (active && !insideClick && e.target.type !== 'checkbox' && e.target.type !== 'select-one') {
      this._handleClose();
    } else {
      this.setState({ data: this.state.data.set('insideClick', false) });
    }
  }

  _removeClickEventListener() {
    document.removeEventListener('click', this._handleOutsideClick);
  }
}

const mapStateToProps = (state) => {
  return {
    tooltip: state.get('tooltip')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (id) => {
      dispatch(tooltipAdd({ id: id }));
    },

    hide: (id) => {
      dispatch(tooltipHide({ id: id }));
    },

    remove: (id) => {
      dispatch(tooltipRemove({ id: id }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tooltip);



// WEBPACK FOOTER //
// ./app/components/shared/tooltip/_Tooltip.jsx